module.exports = __webpack_public_path__ + "img/fr5.320aa8e6.png";